import { createSlice } from '@reduxjs/toolkit';

import { IToastWrapper } from '../../../core/components/toasts/IToastWrapper';
import { ToastStatus } from '../../../core/components/toasts/ToastStatus';
import { ToastReducer } from '../../reducers/ToastMessageReducer';

const initialState: IToastWrapper = {
	text: '',
	status: ToastStatus.WARNING,
	open: false,
	autoClose: false,
};

export const toastSlice = createSlice({
	name: 'toast',
	initialState,
	reducers: ToastReducer,
});

export const { toggleToast } = toastSlice.actions;

export default toastSlice.reducer;
